import styled from 'styled-components';
import { S_FlexBox } from '../../style/FlexBox.style';

export const S_Wrapper = styled(S_FlexBox)``;
